import CustomerService from '@/services/customers/customer-service'
import { alertSuccess } from '@/utilities/sweetalert'

export const state = {
  customers: [],
  customer: {},
  loading: {
    customers: false,
    customerById: null,
    members: false,
    memberById: null
  }
}

export const getters = {
  customers: state => state.customers,
  customer: state => state.customer,
  loading: state => state.loading
}

export const actions = {
  fetchCustomers({ commit }) {
    commit('SET_CUSTOMERS_LOADING', true)

    CustomerService.index()
      .then(response => {
        commit('SET_CUSTOMERS', response.data)
      })
      .catch(() => {
        commit('SET_CUSTOMERS', [])
      })
      .then(() => {
        commit('SET_CUSTOMERS_LOADING', false)
      })
  },

  fetchCustomer({ commit }, id) {
    commit('SET_CUSTOMER_BY_ID_LOADING', id)

    CustomerService.show(id)
      .then(response => {
        commit('SET_CUSTOMER', response.data)
      })
      .catch(() => {
        commit('SET_CUSTOMER', {})
      })
      .then(() => {
        commit('SET_CUSTOMER_BY_ID_LOADING', null)
      })
  },

  storeCustomer({ commit }, payload) {
    commit('SET_CUSTOMERS_LOADING', true)

    CustomerService.store({
      name: payload.name,
      description: payload.description,
      email: payload.email,
      phone: payload.phone,
      wiki: payload.wiki
    })
      .then(response => {
        commit('INSERT_CUSTOMER_TO_CUSTOMERS', response.data) // TODO - replace response with single customer

        alertSuccess({
          title: 'Customer successfully created.'
        })
      })
      .catch(() => {
        commit('SET_CUSTOMER', {})
      })
      .then(() => {
        commit('SET_CUSTOMERS_LOADING', false)
      })
  },

  updateCustomer({ commit }, payload) {
    commit('SET_CUSTOMER_BY_ID_LOADING', payload.id)

    CustomerService.update(payload.id, {
      name: payload.name,
      description: payload.description,
      email: payload.email,
      phone: payload.phone,
      wiki: payload.wiki
    })
      .then(response => {
        commit('SET_CUSTOMER', response.data)

        alertSuccess({
          title: 'Customer successfully updated.'
        })
      })
      .catch(() => {})
      .then(() => {
        commit('SET_CUSTOMER_BY_ID_LOADING', null)
      })
  }
}

export const mutations = {
  SET_CUSTOMERS(state, customers) {
    state.customers = customers
  },
  SET_CUSTOMER(state, customer) {
    state.customer = customer
  },
  SET_CUSTOMERS_LOADING(state, loading) {
    state.loading.customers = loading
  },
  SET_CUSTOMER_BY_ID_LOADING(state, id) {
    state.loading.customerById = id
  },
  INSERT_CUSTOMER_TO_CUSTOMERS(state, customer) {
    state.customers.push(customer)
  }
}
